import { ChangePasswordRequest, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useChangePassword = () =>
  useMutationWithLoading(
    async (params: ChangePasswordRequest & { xTENANTID?: string }) =>
      new UserControllerApi(getConfigObject()).changePassword(
        params,
        params.xTENANTID
      )
  );
